/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".box-contract[_ngcontent-%COMP%]{background-color:#f2f3f8;margin-bottom:10px}"];
export { styles as styles };
